var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.buttonStyle,on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.label)+" "),_c('img',{attrs:{"src":require("../../assets/icons/arrow-down.svg"),"alt":"Seta para baixo"}})])}
var staticRenderFns = []

export { render, staticRenderFns }